import { Component, inject, input, output, signal } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'pds-picture-in-picture',
  templateUrl: './picture-in-picture.component.html',
  styleUrl: './picture-in-picture.component.scss',
  standalone: false,
})
export class PictureInPictureComponent {
  dismiss = output();
  width = input<string>('360px');
  height = input<string>('640px');
  title = input<string>('');
  routerOpenInNew = input<string | string[]>('');
  active = signal<boolean>(false);

  route = inject(Router);

  open() {
    this.active.set(true);
  }

  close() {
    this.active.set(false);
    this.dismiss.emit();
  }

  onClose() {
    this.close();
  }
}
